import { Icon } from "@fluentui/react/lib/Icon";
import { isNullOrEmpty } from "../../lib/helper";
import { useInjectedService } from "../../services/ioc/service-dependency";

import './app-container.css';
import AppStoreLink from "./app-store-link/app-store-link";

interface AppCotainerProps {
    title: string;
    description: string;
    googlePlayStoreLink?: string;
    iosLink?: string;
    icon: string;
    additionalClassName?: string;
    disableIosLink?: boolean;
    iconStyle?: React.CSSProperties;
    comingSoon?: boolean;
    moreLink?: string;
    moreText?: string;
}
const AppContainer = (props: AppCotainerProps) => {

    const { localizationService } = useInjectedService();

    let additionalClassName = "";
    if (!isNullOrEmpty(props.additionalClassName) && props.additionalClassName !== undefined) {
        additionalClassName = props.additionalClassName;
    }

    return <div className={"bbraun-hero bbraun-hero-mutliple-rows bbraun-app-container-row " + additionalClassName}>
        <div className="bbraun-app-container-row-first-column">
            <div className="bbraun-app-container-icon">
                <img style={props.iconStyle} alt={props.title} src={props.icon} />
            </div>
            <div className="bbraun-app-container-text-container">
                <div className="bbraun-hero-headline bbraun-app-container-headline">
                    {props.title}
                </div>
                <div className="bbraun-hero-content bbraun-app-container-content" dangerouslySetInnerHTML={{ __html: props.description }} />
            </div>
        </div>
        <div className="bbraun-app-container-row-second-column">
            {props.moreLink !== undefined &&
                <AppStoreLink moreText={props.moreText} comingSoon={props.comingSoon} ios={false} link={props.moreLink} />
            }
            {props.googlePlayStoreLink !== undefined &&
                <AppStoreLink comingSoon={props.comingSoon} ios={false} link={props.googlePlayStoreLink} />
            }
            {props.disableIosLink === true && props.iosLink !== undefined ?
                <AppStoreLink comingSoon={props.comingSoon} ios={true} link={props.iosLink} />
                :
                props.iosLink !== undefined ?
                    <AppStoreLink comingSoon={props.comingSoon} ios={true} link={props.iosLink} />
                    :
                    <div className="bbraun-app-container-only-android-info">
                        <Icon iconName="Info2" />
                        <div>{localizationService.getLocalizedText("OnlyAndroidUser")}</div>
                    </div>

            }
        </div>
    </div>;
}

export default AppContainer;
